// src\app\components\layout\CreateFootersData.js

import { calcStats } from "../../modules/table.funcs"
import { KIND } from "../../modules/constants"
import { createLseCompaniesFooterData } from "../layout/HomeTables/CreateLseCompaniesTableData"
import { createGovernanceFooterData } from "../layout/HomeTables/CreateGovernanceTableData"
import { createLseCompaniesCommitteesFooterData } from "../layout/HomeTables/createLseCompaniesCommitteesTableData"
import { createKeyDatesFooterData } from "../layout/HomeTables/CreateKeyDatesTableData"
import { createLseBoardFooterData } from "../layout/HomeTables/CreateBoardTableData"
import { createLsePeopleFootersData } from "../layout/HomeTables/CreateLsePeopleTableData"
import { createLsePeopleCommitteesFootersData } from "../layout/HomeTables/CreateLsePeopleCommitteesTableData"
import { createLseRolesFootersData } from "../layout/HomeTables/CreateLseRolesTableData"
import { createLseRolesCommitteesFootersData } from "../layout/HomeTables/CreateLseRolesCommitteesTableData"
import { createLseNewsFootersData } from "../layout/HomeTables/CreateLseNewsTableData"
import { createAdvisersFooterData } from "../layout/HomeTables/CreateAdvisersTableData"
import { createAdvisersListFooterData } from "../layout/HomeTables/CreateAdvisersListTableData"

const createFootersData = props => {
  // console.log('createFootersData props:', props)

  const { kind, stats } = props

  for (const property in stats)
    calcStats(stats[property])

  switch (kind) {

    case KIND.LSE.COMPANIES.BOARD:
      return createLseBoardFooterData(props)

    case KIND.LSE.COMPANIES.OVERVIEW:
      return createLseCompaniesFooterData(props)

    case KIND.LSE.COMPANIES.GOVERNANCE:
      return createGovernanceFooterData(props)

    case KIND.LSE.COMPANIES.COMMITTEES:
      return createLseCompaniesCommitteesFooterData(props)

    case KIND.LSE.COMPANIES.DATES:
      return createKeyDatesFooterData(props)

    case KIND.LSE.COMPANIES.ADVISERS:
      return createAdvisersFooterData(props)

    case KIND.LSE.ROLES.BOARD:
      return createLseRolesFootersData(props)

    case KIND.LSE.ROLES.COMMITTEES:
      return createLseRolesCommitteesFootersData(props)

    case KIND.LSE.PEOPLE.BOARD:
      return createLsePeopleFootersData(props)

    case KIND.LSE.PEOPLE.COMMITTEES:
      return createLsePeopleCommitteesFootersData(props)

    case KIND.LSE.NEWS:
      return createLseNewsFootersData(props)

    case KIND.LSE.ADVISERS:
      return createAdvisersListFooterData(props)

    default:
      // console.log('No case for kind:', kind)
      return {
        totals: [],
        means: [],
      }
  }
}

export default createFootersData